import Button from "../../atoms/Button"
import Modal from "../../molecules/Modal"
import styles from "./index.module.scss"
import DrinkCoffee from "../../../assets/img/drink_coffee.svg"
import RcmpCheckBox from "../../atoms/Checkbox"
import intl from "react-intl-universal"

export default function RcmpTutorialModal(props) {
  const { bIsOpen, fnOnClose, onChange, cHeaderText, cMessage } = props

  function fnOnRequestClose() {
    fnOnClose?.()
  }

  return (
    <Modal isOpen={bIsOpen} size="sm" onRequestClose={fnOnRequestClose}>
      <Modal.Header onClose={fnOnRequestClose}>{cHeaderText}</Modal.Header>
      <Modal.Content>
        <div className={styles.contentContainer}>
          <img src={DrinkCoffee} />
          <p>
            {cMessage?.fistParagraph || cMessage}
          </p>
          <p>
            {cMessage?.secondParagraph}

          </p>
          <RcmpCheckBox
            cLabel="Não mostrar novamente"
            cSize="sm"
            onChange={() => onChange(e => !e)}
          />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <div className={styles.footerContainer}>
          <Button variant="outline" type="button" onClick={fnOnRequestClose}>
            {intl.get("ModalActivityModelWarning.understood")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
